import { Controller } from "stimulus";
import { getRequest } from "init/ajax";

export default class extends Controller {

    openCalendarModal() {
        window.dispatchEvent(new Event('open-calendar-modal', {bubbles: true}));
    }

    updateCheckInDateQuote() {
        // get the value of the hidden input field
        window.dispatchEvent(new Event('update-check-in-date-quote', {bubbles: true}));
    }

    updateCheckOutDateQuote() {
        window.dispatchEvent(new Event('update-check-out-date-quote', {bubbles: true}));
    }
}
